export function buildMessageIdentity(message) {
  if (message.msgId > 0) {
    if (message.sessionType === 'group') {
      return `server:${message.sessionKey}:${message.msgId}:${message.from}:${message.msgType ?? 0}:${message.ts}`;
    }
    return `server:${message.sessionKey}:${message.msgId}`;
  }

  return `local:${message.localId}`;
}

export function dedupeMessagesByIdentity(messages) {
  const seen = new Set();
  const deduped = [];

  for (const message of messages) {
    const identity = buildMessageIdentity(message);
    if (seen.has(identity)) {
      continue;
    }
    seen.add(identity);
    deduped.push(message);
  }

  return deduped;
}

export function createOptimisticTextMessage({ session, text, userId, nextLocalMessageId, now }) {
  return {
    localId: nextLocalMessageId(),
    msgId: 0,
    sessionKey: session.sessionKey,
    sessionId: session.sessionId,
    sessionType: session.sessionType,
    from: userId,
    text,
    ts: now(),
    dir: 'out',
    status: 'pending',
  };
}

export function applyOptimisticMessageToSession(session, optimisticMessage, userId) {
  return {
    ...session,
    updatedAt: optimisticMessage.ts,
    lastMsgPreview: optimisticMessage.text,
    lastMsgFromUserId: userId,
    messages: dedupeMessagesByIdentity([...session.messages, optimisticMessage]),
    historyState: session.historyState === 'idle' ? 'ready' : session.historyState,
    historyError: null,
  };
}

export function applyAckToSession(session, { localId, serverMsgId, serverTimestamp }) {
  const updatedMessages = session.messages.map((message) => (
    message.localId === localId
      ? { ...message, msgId: serverMsgId, status: 'sent', ts: serverTimestamp }
      : message
  ));

  return {
    ...session,
    updatedAt: serverTimestamp,
    lastMsgId: serverMsgId || session.lastMsgId,
    messages: dedupeMessagesByIdentity(updatedMessages),
  };
}

export function hydrateSessionMessages(session, freshMessages) {
  return {
    ...session,
    messages: dedupeMessagesByIdentity(freshMessages.slice().reverse()),
    historyState: 'ready',
    historyError: null,
  };
}
